var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTop2Leaderboard = function SvgIconTop2Leaderboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__a)",
    d: "M17.216 19.594v-1.92c0-.47.064-.87.192-1.2.139-.33.373-.63.704-.896.33-.278.779-.544 1.344-.8l2.192-1.008c.533-.246.955-.56 1.264-.944.31-.395.464-.902.464-1.52 0-.747-.208-1.328-.624-1.744-.416-.416-1.003-.624-1.76-.624-.747 0-1.333.208-1.76.624-.427.416-.64.997-.64 1.744h-1.504c0-.672.139-1.29.416-1.856A3.208 3.208 0 0 1 18.8 8.106c.576-.342 1.307-.512 2.192-.512.885 0 1.61.17 2.176.512.576.33 1.003.768 1.28 1.312.288.544.432 1.136.432 1.776v.224c0 .842-.245 1.552-.736 2.128-.48.576-1.13 1.05-1.952 1.424L20 15.978c-.49.224-.821.448-.992.672-.17.224-.256.522-.256.896v1.472l-.416-.736h6.688v1.312h-7.808Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__b)",
    d: "M5.105 13.581s.56-1.332-.404-2.716c-.965-1.382-2.414-1.617-2.414-1.617s-.616 1.574.325 2.921c.94 1.349 2.493 1.412 2.493 1.412Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__c)",
    d: "M7.693 13.73s1.464-.521 1.962-2.089c.499-1.566-.557-2.886-.557-2.886s-1.313.654-1.825 2.263c-.512 1.607.42 2.711.42 2.711Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__d)",
    d: "M8.315 15.458c-.297 1.66.77 2.635.77 2.635s1.385-.708 1.675-2.325c.288-1.619-.93-2.79-.93-2.79s-1.217.82-1.515 2.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__e)",
    d: "M12.018 15.738s-1.134.932-1.274 2.611c-.14 1.683 1.014 2.552 1.014 2.552s1.31-.835 1.447-2.473c.136-1.638-1.187-2.69-1.187-2.69Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__f)",
    d: "M15.255 23.513s1.016-1.178.675-2.786c-.342-1.608-1.912-2.233-1.912-2.233s-.818 1.219-.469 2.868c.351 1.649 1.706 2.151 1.706 2.151Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__g)",
    d: "M6.223 10.116s1.206-.798 1.17-2.483C7.36 5.948 6.284 4.948 6.284 4.948s-1.384.967-1.35 2.611c.034 1.643 1.289 2.557 1.289 2.557Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__h)",
    d: "M6.008 16.942s.141-1.439-1.187-2.476c-1.33-1.036-2.784-.834-2.784-.834s-.124 1.685 1.172 2.696c1.296 1.012 2.799.614 2.799.614Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__i)",
    d: "M8.028 20.099s-.182-1.434-1.707-2.15c-1.527-.716-2.9-.195-2.9-.195s.254 1.671 1.741 2.37c1.489.696 2.866-.025 2.866-.025Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__j)",
    d: "M10.462 22.503s-.605-1.312-2.276-1.531c-1.673-.22-2.823.69-2.823.69s.748 1.517 2.377 1.733c1.629.212 2.722-.892 2.722-.892Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__k)",
    d: "M11.511 23.488c-1.686-.018-2.72 1.024-2.72 1.024s.923 1.415 2.566 1.433c1.645.018 2.598-1.21 2.598-1.21s-.758-1.23-2.444-1.247Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__l)",
    d: "m6.638 11.021-.79-.156c-.015.086-1.561 8.668 10.828 14.584l.346-.726C5.226 19.09 6.575 11.348 6.638 11.021Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__m)",
    d: "M35.822 13.605s-.56-1.332.404-2.715c.964-1.384 2.414-1.618 2.414-1.618s.615 1.572-.326 2.92c-.938 1.35-2.492 1.413-2.492 1.413Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__n)",
    d: "M33.236 13.757s-1.464-.521-1.964-2.088c-.498-1.566.557-2.886.557-2.886s1.314.654 1.827 2.262c.511 1.608-.42 2.712-.42 2.712Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__o)",
    d: "M32.61 15.478c.297 1.66-.77 2.635-.77 2.635s-1.385-.708-1.675-2.325c-.287-1.619.93-2.79.93-2.79s1.217.82 1.515 2.48Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__p)",
    d: "M28.909 15.761s1.134.93 1.274 2.613c.14 1.682-1.014 2.55-1.014 2.55s-1.31-.835-1.447-2.473c-.136-1.638 1.187-2.69 1.187-2.69Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__q)",
    d: "M25.67 23.544s-1.014-1.177-.673-2.785c.342-1.608 1.913-2.234 1.913-2.234s.817 1.218.468 2.869c-.35 1.65-1.707 2.15-1.707 2.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__r)",
    d: "M34.702 10.147s-1.204-.796-1.168-2.482c.034-1.685 1.11-2.686 1.11-2.686s1.385.967 1.35 2.612c-.035 1.643-1.292 2.556-1.292 2.556Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__s)",
    d: "M34.92 16.974s-.141-1.44 1.187-2.476c1.33-1.037 2.785-.834 2.785-.834s.124 1.685-1.172 2.696c-1.297 1.012-2.8.614-2.8.614Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__t)",
    d: "M32.899 20.123s.181-1.434 1.708-2.151c1.527-.715 2.899-.195 2.899-.195s-.254 1.673-1.742 2.37c-1.488.696-2.865-.024-2.865-.024Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__u)",
    d: "M30.464 22.528s.606-1.313 2.278-1.533c1.674-.22 2.822.691 2.822.691s-.748 1.516-2.377 1.731c-1.63.215-2.723-.89-2.723-.89Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__v)",
    d: "M29.416 23.512c1.686-.017 2.72 1.025 2.72 1.025s-.921 1.414-2.566 1.435c-1.643.017-2.596-1.21-2.596-1.21s.757-1.231 2.442-1.25Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__w)",
    d: "m34.286 11.044.792-.155c.016.086 1.561 8.667-10.829 14.582l-.345-.725C35.698 19.113 34.35 11.37 34.286 11.044Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__a",
    x1: 21,
    x2: 21,
    y1: 0.594,
    y2: 27.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__b",
    x1: 3.009,
    x2: 4.281,
    y1: 9.054,
    y2: 13.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__c",
    x1: 7.843,
    x2: 8.992,
    y1: 9.092,
    y2: 13.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__d",
    x1: 8.882,
    x2: 10.111,
    y1: 13.232,
    y2: 17.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__e",
    x1: 11.303,
    x2: 12.576,
    y1: 15.93,
    y2: 20.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__f",
    x1: 14.054,
    x2: 15.391,
    y1: 18.485,
    y2: 23.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__g",
    x1: 5.52,
    x2: 6.808,
    y1: 5.152,
    y2: 9.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__h",
    x1: 3.462,
    x2: 4.556,
    y1: 13.25,
    y2: 17.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__i",
    x1: 5.276,
    x2: 6.186,
    y1: 17.25,
    y2: 20.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__j",
    x1: 7.575,
    x2: 8.292,
    y1: 20.82,
    y2: 23.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__k",
    x1: 11.06,
    x2: 11.733,
    y1: 23.456,
    y2: 25.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__l",
    x1: 9.004,
    x2: 13.376,
    y1: 10.02,
    y2: 26.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__m",
    x1: 37.918,
    x2: 36.646,
    y1: 9.078,
    y2: 13.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__n",
    x1: 33.085,
    x2: 31.936,
    y1: 9.119,
    y2: 13.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__o",
    x1: 32.043,
    x2: 30.814,
    y1: 13.252,
    y2: 17.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__p",
    x1: 29.624,
    x2: 28.35,
    y1: 15.953,
    y2: 20.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__q",
    x1: 26.874,
    x2: 25.536,
    y1: 18.515,
    y2: 23.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__r",
    x1: 35.407,
    x2: 34.119,
    y1: 5.184,
    y2: 9.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__s",
    x1: 37.466,
    x2: 36.373,
    y1: 13.282,
    y2: 17.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__t",
    x1: 35.651,
    x2: 34.741,
    y1: 17.273,
    y2: 20.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__u",
    x1: 33.352,
    x2: 32.635,
    y1: 20.844,
    y2: 23.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__v",
    x1: 29.868,
    x2: 29.195,
    y1: 23.482,
    y2: 25.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__w",
    x1: 31.922,
    x2: 27.551,
    y1: 10.043,
    y2: 26.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9FAC"
  })))));
};
export default SvgIconTop2Leaderboard;